import "./App.css";
import LeftPane from "./Components/LeftPane/LeftPane";
import Nav from "./Components/Nav/Nav";
import Dashboard from "./Pages/Dashboard/Dashboard";
import StudentManagement from "./Pages/StudentManagement/StudentManagement";
import ExistingStudent from "./Pages/existingstudent/ExistingStudent";
import Application from "./Pages/Application/Application";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Advertisment from "./Pages/Advertisment/Advertisment";
import Circular from "./Pages/Circular/Circular";
import Admission from "./Pages/Admission/Admission";
import Setup from "./Pages/Fees/Setup/Setup";
import Report from "./Pages/Fees/Report/Report";
import Teacher from "./Pages/Teacher/Teacher";
import Login from "./Pages/Login/Login";
 import AddUser from "./Pages/Roles/user/AddUser"; // Added import for AddUser
import AddRole from "./Pages/Roles/role/AddRole";   // Added import for AddRole

import { SearchProvider } from "./context/SearchContext";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./utils/ProtectedRoute"; // Import the ProtectedRoute component
import { Toaster } from "react-hot-toast"; //Import toaster
import React, { useState } from "react";
import ReportDetails from "./Pages/Fees/ReportDetails/ReportDetails";
import AdminLogin from "./Pages/Login/AdminLogin";

function App() {
  const location = useLocation(); // Get the current path
  const [isLeftPaneOpen, setIsLeftPaneOpen] = useState(true);

  const toggleLeftPane = () => setIsLeftPaneOpen((prev) => !prev);

  return (
    <SearchProvider>
      <Toaster position="top-center" />
      <Routes>
        <Route exact path="/admin-login" element={<AdminLogin />} />
        <Route exact path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Dashboard"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Dashboard />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/advertisment"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Advertisment"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Advertisment />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/fee_setup"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Fees Management"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Setup />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/fee_report"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Fees Management"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Report />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/fee_report/:id"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Fees Report Details"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <ReportDetails />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Teacher"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Teacher />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/circular"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Circular"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Circular />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/students"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Student Management"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <StudentManagement />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
  exact
  path="/existingstudent"
  element={
    <ProtectedRoute>
      <div className="App">
        <LeftPane isOpen={isLeftPaneOpen} />
        <div className="main_container">
          <Nav
            title="Existing Student"
            activePath={location.pathname}
            onHamburgerClick={toggleLeftPane}
            isOpen={isLeftPaneOpen}
          />
          <ExistingStudent />
        </div>
        <div className="bottom-theme"></div>
      </div>
    </ProtectedRoute>
  }
/>
        <Route
          exact
          path="/application"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Application"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Application />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/new_admission"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="New Admission"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <Admission />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/about-us"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="About Us"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <AboutUs />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        {/* add user */}
           <Route
          exact
          path="/add_user"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Add User"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <AddUser />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />
        {/* add role */}
          
        <Route
          exact
          path="/add_role"
          element={
            <ProtectedRoute>
              <div className="App">
                <LeftPane isOpen={isLeftPaneOpen} />
                <div className="main_container">
                  <Nav
                    title="Add Role"
                    activePath={location.pathname}
                    onHamburgerClick={toggleLeftPane}
                    isOpen={isLeftPaneOpen}
                  />
                  <AddRole />
                </div>
                <div className="bottom-theme"></div>
              </div>
            </ProtectedRoute>
          }
        />


      </Routes>
    </SearchProvider>
  );
}

export default App;
